


































































































































































































































































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {GithubOrganizationCollection} from '@/model/collection/GithubOrganizationCollection'
import CDOrganizationsNav from '@/components/communityDevelopment/CDOrganizationsNav.vue'
import CDOrganizationWheel from '@/components/communityDevelopment/CDOrganizationWheel.vue'
import CDOrganizationInformation from '@/components/communityDevelopment/CDOrganizationInformation.vue'
import CDOrganizationSocialLinks from '@/components/communityDevelopment/CDOrganizationSocialLinks.vue'
import CDRepositoryDescription from '@/components/communityDevelopment/CDRepositoryDescription.vue'
import CDTopLanguages from '@/components/communityDevelopment/CDTopLanguages.vue'
import CDRepositories from '@/components/communityDevelopment/CDRepositories.vue'
import CDCommits from '@/components/communityDevelopment/CDCommits.vue'
import CDPopularity from '@/components/communityDevelopment/CDPopularity.vue'
import CDContributors from '@/components/communityDevelopment/CDContributors.vue'
import {GithubOrganization} from '@/model/resource/GithubOrganization'
import {GithubRepository} from '@/model/resource/GithubRepository'
import {CDLanguageRatioItem} from './CDTopLanguages.vue'
import {GithubRepositoryLanguageCollection} from '@/model/collection/GithubRepositoryLanguageCollection'
import {$} from '@/facade'
import {GithubRepositoryCommitCollection} from '@/model/collection/GithubRepositoryCommitCollection'
import {GithubRepositoryUserCollection} from '@/model/collection/GithubRepositoryUserCollection'
import {GithubRepositoryCollection} from '@/model/collection/GithubRepositoryCollection'
import {GithubOrganizationSocialTypeCollection} from '@/model/collection/GithubOrganizationSocialTypeCollection'
import {GithubOrganizationSocialType} from '@/model/resource/GithubOrganizationSocialType'

@Component({
  components: {
    CDOrganizationsNav,
    CDOrganizationWheel,
    CDOrganizationInformation,
    CDOrganizationSocialLinks,
    CDRepositoryDescription,
    CDTopLanguages,
    CDRepositories,
    CDCommits,
    CDPopularity,
    CDContributors,
  },
})
export default class CDOrganizationsSection extends Mixins(MixinScreenSize) {
  @Prop({type: GithubOrganizationCollection, required: true})
  organizationCollection!: GithubOrganizationCollection

  @Prop({type: GithubRepositoryCollection, default: null})
  repositoryCollection!: GithubRepositoryCollection | null

  @Prop({type: GithubRepositoryCommitCollection, required: true})
  repositoryCommitCollection!: GithubRepositoryCommitCollection

  @Prop({type: Object, default: () => ({})})
  commitsByOrganization!: Record<number, number>

  @Prop({type: Boolean, default: false})
  selectionLocked!: boolean

  @Prop({type: Number, default: null})
  selectedOrganizationId!: number | null

  @Prop({type: Number, default: null})
  selectedRepositoryId!: number | null

  allSocialTypes: GithubOrganizationSocialType[] = []
  topLanguages: CDLanguageRatioItem[] = []
  repositories: number | null = null
  commits: number | null = null
  contributors: number | null = null
  stars: number | null = null
  showMobileOrgFilter = false

  get hasAnyData(): boolean {
    return (
      (this.organizationCollection &&
        this.organizationCollection.items.length > 0) ||
      (this.repositoryCollection &&
        this.repositoryCollection.items.length > 0) ||
      (this.repositoryCommitCollection &&
        this.repositoryCommitCollection.items.length > 0)
    )
  }

  get selectedOrganization(): GithubOrganization | null {
    if (this.selectedOrganizationId === null) return null
    return (
      this.organizationCollection.items.find(
        it => it.$id === this.selectedOrganizationId
      ) || null
    )
  }

  get selectedRepository(): GithubRepository | null {
    if (this.selectedRepositoryId === null) return null
    return (
      (this.repositoryCollection?.items || []).find(
        it => it.$id === this.selectedRepositoryId
      ) || null
    )
  }

  get displayedStars(): number | null {
    if (this.selectedRepository !== null) {
      return this.selectedRepository.stars
    }
    return this.stars
  }

  get filteredSocialTypes(): GithubOrganizationSocialType[] {
    if (this.selectedOrganizationId === null) return []
    return this.allSocialTypes.filter(
      s => s.githubOrganization?.$id === this.selectedOrganizationId
    )
  }

  get mobileOrgFilterBadgeCount(): number {
    if (this.selectedOrganizationId === null) {
      return this.organizationCollection?.items?.length ?? 0
    }
    return this.repositoryCollection?.items?.length ?? 0
  }

  onMobileFilterSelectOrganization(id: number | null) {
    this.onSelectOrganization(id)
    this.showMobileOrgFilter = false
  }

  onMobileFilterSelectRepository(id: number | null) {
    this.onSelectRepository(id)
    this.showMobileOrgFilter = false
  }

  async mounted() {
    this.populateResources()
    this.fetchAllSocialTypes()
  }

  async fetchAllSocialTypes() {
    const collection = new GithubOrganizationSocialTypeCollection()
    collection.perPage = 200
    await collection.queryAsPage()
    this.allSocialTypes = collection.items
  }

  @Watch('selectedOrganizationId')
  onSelectedOrganizationIdChange() {
    this.populateResources()
  }

  @Watch('selectedRepositoryId')
  onSelectedRepositoryIdChange() {
    this.populateResources()
  }

  async populateResources() {
    const promises: Array<Promise<unknown>> = [
      this.populateLanguages(),
      this.populateRepositories(),
      this.populateCommits(),
      this.populateContributors(),
      this.populatePopularity(),
    ]

    await $.await.run('populateOrganizationMetrics', () =>
      Promise.all(promises)
    )
  }

  async populateLanguages() {
    const collection = new GithubRepositoryLanguageCollection()

    if (this.selectedRepositoryId !== null) {
      collection.idGithubRepositoryFk = this.selectedRepositoryId
      collection.idOrganizationFk = null
    } else {
      collection.idGithubRepositoryFk = null
      collection.idOrganizationFk = this.selectedOrganizationId
    }

    const response = await collection.sumByOrganization()

    type SumLanguage = {
      name?: string | null
      language?: string | null
      amountInBytes?: number | null
      ratio?: number | null
    }

    const languages: SumLanguage[] = Array.isArray((response as any)?.data)
      ? ((response as any).data as SumLanguage[])
      : ((response as any) as SumLanguage[])

    const totalBytes = languages.reduce(
      (acc: number, it: SumLanguage) => acc + (it.amountInBytes ?? 0),
      0
    )

    this.topLanguages = languages.map((it: SumLanguage) => {
      const amount = it.amountInBytes ?? 0
      const ratio =
        typeof it.ratio === 'number' && !Number.isNaN(it.ratio)
          ? it.ratio
          : totalBytes > 0
          ? amount / totalBytes
          : 0

      return {
        language: it.name ?? it.language ?? '',
        ratio,
      }
    })
  }

  async populateRepositories() {
    if (this.selectedRepositoryId !== null) {
      this.repositories = null
      return
    }
    const collection = new GithubRepositoryCollection()
    collection.idGithubRepositoryFk = null
    collection.idOrganizationFk = this.selectedOrganizationId
    this.repositories = await collection.countByOrganization()
  }

  async populateCommits() {
    const collection = new GithubRepositoryCommitCollection()
    if (this.selectedRepositoryId !== null) {
      collection.idGithubRepositoryFk = this.selectedRepositoryId
      collection.idOrganizationFk = null
    } else {
      collection.idGithubRepositoryFk = null
      collection.idOrganizationFk = this.selectedOrganizationId
    }
    this.commits = await collection.sumCommitsByOrganization()
  }

  async populateContributors() {
    const collection = new GithubRepositoryUserCollection()
    if (this.selectedRepositoryId !== null) {
      collection.idGithubRepositoryFk = this.selectedRepositoryId
      collection.idOrganizationFk = null
    } else {
      collection.idGithubRepositoryFk = null
      collection.idOrganizationFk = this.selectedOrganizationId
    }
    this.contributors = await collection.sumContributorsByOrganization()
  }

  async populatePopularity() {
    const collection = new GithubRepositoryCollection()
    collection.idOrganizationFk = this.selectedOrganizationId
    this.stars = await collection.sumStarsByOrganization()
  }

  onSelectOrganization(id: number | null) {
    this.$emit('selectOrganization', id)
  }

  onSelectRepository(id: number | null) {
    if (id === null) {
      this.$emit('selectRepository', null)
      return
    }
    const next = this.selectedRepositoryId === id ? null : id
    this.$emit('selectRepository', next)
  }
}
